import * as smartlog from '@pushrocks/smartlog';
import { SmartlogDestinationDevtools } from '@pushrocks/smartlog-destination-devtools';

export const logger = new smartlog.Smartlog({
  logContext: {
    company: 'Lossless GmbH',
    companyunit: 'Lossless Cloud',
    containerName: 'web',
    environment: 'production',
    runtime: 'chrome',
    zone: 'servezone'
  },
  minimumLogLevel: 'info'
});

logger.addLogDestination(new SmartlogDestinationDevtools());
